import { IFRAME_KEYS } from "../../pages/LandingPage/constants";

export const isUnifyLaunch = (search: string): boolean => {
  const UNIFY_LAUNCH_MODE = IFRAME_KEYS.MODE.UNIFY_MODE;
  const LAUNCH_MODE_PARAM = IFRAME_KEYS.PARAMS.LAUNCH_MODE;
  const launchMode = new URLSearchParams(search).get(LAUNCH_MODE_PARAM);

  return launchMode?.trim().toLowerCase() === UNIFY_LAUNCH_MODE;
};

export const isPaymentsLaunch = (search: string): boolean => {
  const PAYMENTS_LAUNCH_MODE = IFRAME_KEYS.MODE.PAYMENTS_MODE;
  const LAUNCH_MODE_PARAM = IFRAME_KEYS.PARAMS.LAUNCH_MODE;

  const launchMode = new URLSearchParams(search).get(LAUNCH_MODE_PARAM);

  return launchMode?.trim().toLowerCase() === PAYMENTS_LAUNCH_MODE;
};
